<ng-container *ngIf="!isLoading; else loading">
	<div class="services-title-bar" translate>{{ headerLabel }}</div>
	<button
		type="button"
		mat-button color="primary"
		class="services-label"
		[routerLink]="btnRouterLink"
		(click)="newGuarantee()">
		<span class="widget-resize-double-line" translate>{{ btnLabel }}</span>
		<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
	</button>
<div class="service-box-footer">
	<ng-container *ngIf="draftCount > 0">
		<button type="button" mat-button color="primary" (click)="newGuarantee()" [routerLink]="['/guarantee-requests/drafts']">
			<span class="widget-draft-number">{{draftCount | copoNumber: "number"}}</span>
			<span class="widget-draft" translate>claim.display-saved-drafts</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</ng-container>
</div>

</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>